import React from 'react';
import { Menu } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import type { MenuProps } from 'antd';
import './SidebarMenu.css';

interface SidebarMenuProps {
  collapsed?: boolean;
  defaultSelectedKeys?: string[];
  onMenuClick?: (key: string) => void;
}

const ROUTE_MAP = {
  '3': '/property-sale-histories',
  '4': '/notification-properties',
  '5': '/simulation',
} as const;

const MENU_KEY_MAP = {
  '/property-sale-histories': '3',
  '/notification-properties': '4',
  '/simulation': '5',
} as const;

const SidebarMenu: React.FC<SidebarMenuProps> = ({
  collapsed = true,
  defaultSelectedKeys = ['1'],
  onMenuClick
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems: MenuProps["items"] = [
    {
      key: "3",
      icon: null,
      label: collapsed
        ? <img src="/sidebar-icon-1.png" alt="1" style={{ width: 24, height: 24 }} />
        : <><img src="/sidebar-icon-1.png" alt="1" style={{ width: 24, height: 24 }} />物件一覧</>,
    },
    {
      key: "4",
      icon: null,
      label: collapsed
        ? <img src="/sidebar-icon-2.png" alt="2" style={{ width: 24, height: 24 }} />
        : <><img src="/sidebar-icon-2.png" alt="2" style={{ width: 24, height: 24 }} />通知物件一覧</>,
    },
    {
      key: "5",
      icon: null,
      label: collapsed
        ? <img src="/sidebar-icon-3.svg" alt="3" style={{ width: 24, height: 24 }} />
        : <><img src="/sidebar-icon-3.svg" alt="3" style={{ width: 24, height: 24 }} />シミュレーション</>,
    },
  ];

  const handleMenuClick: MenuProps['onClick'] = (e) => {
    const route = ROUTE_MAP[e.key as keyof typeof ROUTE_MAP];
    if (route) {
      navigate(route);
    }

    if (onMenuClick) {
      onMenuClick(e.key);
    }
  };

  const getCurrentMenuKey = () => {
    return MENU_KEY_MAP[location.pathname as keyof typeof MENU_KEY_MAP] || defaultSelectedKeys[0];
  };

  const getDefaultOpenKeys = () => {
    const currentKey = getCurrentMenuKey();
    if (['3'].includes(currentKey)) return ['sub1'];
    return [];
  };

  return (
    <div className='sidebar-menu'>
      <div className={`logo ${collapsed ? "collapsed" : ""}`}>
        <div className="logo-icon">B</div>
        {!collapsed && (
          <div className='logo-text'>
            <span className='logo-title'>BUKKEN BANK</span>
            <span className='logo-subtitle'>v2.0</span>
          </div>
        )}
      </div>

      <Menu
        theme='light'
        selectedKeys={[getCurrentMenuKey()]}
        defaultOpenKeys={getDefaultOpenKeys()}
        mode='inline'
        items={menuItems}
        onClick={handleMenuClick}
        className='main-menu'
      />
    </div>
  );
};

export default SidebarMenu;